@if (config && !config.showLoader) {
    <div class="container" [class.clickable]="!invalidConfig" (click)="openWorkspace()">
        @if (invalidConfig) {
            <div class="error-message">{{ 'dashboard.moduleDetailWidget.invalidConfigMessage' | transloco }}</div>
        } @else {
            @if (customTitle) {
                <div class="header">{{ customTitle }}</div>
            } @else {
                @let incidentItemName = 'dashboard.moduleDetailWidget.incidentItemName' | transloco;
                <div class="header">
                    {{
                        'dashboard.moduleDetailWidget.countOfLabel'
                            | transloco: { item: isIncidentItem ? incidentItemName : itemName }
                    }}
                </div>
                @if (usesAllIncidentsPreset) {
                    <div class="subtitle">
                        ({{ 'dashboard.moduleDetailWidget.allIncidentsPreset' | transloco }})
                    </div>
                } @else if (presetName) {
                    <div class="subtitle">({{ presetName }})</div>
                }
            }
            <div class="count">{{ count }}</div>
        }
    </div>
}
